import * as React from "react";

import { EditorProps, EditorState } from "./EnvironmentVariableEditor";
import { CustomBooleanSwitch } from "../../shared/components/CustomSwitch";

export class BooleanEditor extends React.PureComponent<React.PropsWithChildren<EditorProps<boolean>>, EditorState<boolean>> {
    constructor(props: EditorProps<boolean>) {
        super(props);
        this.state = { value: props.value };
    }
    public render() {
        return (
            <div
                title={this.props.value == null ? FRENDS.Localizations.NotSet : undefined}
                style={{ width: this.props.value == null ? 110 : "auto" }}
            >
                <CustomBooleanSwitch
                    toggled={this.props.value === null ? null : (this.state.value || false)}
                    onChange={this.handleToggleChange}
                />
                {this.props.children}
            </div>
        );
    }

    public static getDerivedStateFromProps(props: EditorProps<boolean>, state: EditorState<boolean>) {
        if (props.value !== state.value) {
            return {
                value: props.value
            }
        }
        return null;
    }

    private handleToggleChange = (newValue: boolean) => {
        this.setState({ value: newValue });
        if (this.props.value !== newValue) {
            this.props.updateSingleValue(newValue, this.props.environmentId);
        }
    }
}
